import { Component, HostBinding, OnInit } from '@angular/core';
import { Router } from '@angular/router';

@Component({
    standalone: false,
    selector: 'app-console',
    templateUrl: './console.component.html',
    styleUrls: ['./console.component.scss']
})
export class ConsoleComponent implements OnInit {
    @HostBinding('class')
    hostClass = 'console';

    constructor(private readonly router: Router) {}

    isOpened(path: string): boolean {
        return this.router.url === `/console/${path}`;
    }

    ngOnInit(): void {}
}
